import { take, call, put, fork } from 'redux-saga/effects'
import { REQUEST_FEEDBACK_REPLY, SEND_FEEDBACK_REPLY_FORM } from 'actions/feedbackReplyForm/constants'
import * as api from 'api/feedbackReplyForm'
import * as action from 'actions'
import * as actionFeedback from 'actions/feedbackReplyForm'
import {reset} from 'redux-form'

export function * feedbackReplyPageRequestFlow () {
  while (true) {
    try {
      let {payload} = yield take(REQUEST_FEEDBACK_REPLY)
      yield put(action.sendingRequest(true))
      yield put(action.showProgressBar())
      let response = yield call(api.checkFeedbackToken, payload.token)
      let result = response.data
      if (!result.token_error) {
        let responseFeedbackReply = yield call(api.getFeedbackReplyForm, result.feedback_id)
        yield put(actionFeedback.setFeedbackCustomers(responseFeedbackReply.data))
      }
    } catch (e) {
      if (e.data.token_error) {
        yield put(actionFeedback.setInvalidToken(true))
      }
    } finally {
      yield put(action.sendingRequest(false))
      yield put(action.hideProgressBar())
    }
  }
}

export function * sendFeedbackReplyForm () {
  while (true) {
    let {payload} = yield take(SEND_FEEDBACK_REPLY_FORM)
    try {
      $('#submit-feedback').prop('disabled', true)
      yield put(action.sendingRequest(true))
      yield put(action.showProgressBar())
      yield call(api.sendFeedbackReplyForm, {message: payload.message, token: payload.token})
      yield put(actionFeedback.requestFeedbackReply(payload.token))
      $('#submit-feedback').prop('disabled', false)
    } finally {
      yield put(reset('messageForm'))
      yield put(action.sendingRequest(false))
      yield put(action.hideProgressBar())
    }
  }
}

export default function * feedbackReplyFeedbackSaga () {
  yield fork(feedbackReplyPageRequestFlow)
  yield fork(sendFeedbackReplyForm)
}



// WEBPACK FOOTER //
// ./app/sagas/feedbackReplyForm/index.js